module.exports = __webpack_public_path__ + "static/img/env18.efbf182.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/env18.png
// module id = 111
// module chunks = 4